export function getFinancialYear(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  if (month >= 4) {
    return `${String(year).slice(2)}${String(year + 1).slice(2)}`;
  }

  return `${String(year - 1).slice(2)}${String(year).slice(2)}`;
}

export function generateInvoiceNo(sequence = 1) {
  const fy = getFinancialYear();
  return `SAAM/OS/${fy}/${String(sequence).padStart(5, "0")}`;
}

export function generateReceiptNo(sequence = 1) {
  const fy = getFinancialYear();
  return `REC/OS/${fy}/${String(sequence).padStart(5, "0")}`;
}